import React from 'react';
import {Box} from '@mui/material';
import UrlaubsantragOverview from './UrlaubsantragOverview';
import UrlaubsantragTable from './UrlaubsantragTable';
import {useUrlaubsantrag} from '../../../../Contexts/Urlaubsantrag/useUrlaubsantrag';
import UserContext from '../../../../Contexts/UserContext/UserContext';
import {get} from 'http';

const Urlaubsantrag = () => {
  let isApprover = false;
  const {user_roll, email, name} = React.useContext(UserContext);
  if (user_roll?.includes('Administrator') || user_roll?.includes('Admin Urlaub')) {
    isApprover = true;
  }
  const canEditApproved = user_roll?.includes('Admin Urlaub') ?? false;

  // Use the hook in the parent component
  const {
    loading,
    meineAntraege,
    pendingAntraege,
    approvedAntraege,
    snackbar,
    setSnackbar,
    formData,
    setFormData,
    openDialog,
    setOpenDialog,
    vacationDaysInfo,
    totalVacationDays,
    remainingVacationDays,
    pendingVacationDays,
    initialRemainingDays,
    calculateProjectedRemainingDays,
    calculateProjectedPendingDays,
    deleteRequest,
    editRequest,
    processRequest,
    submitRequest,
    resetForm,
    loadPendingRequests,
    getExistingVacationDates,
    checkForOverlap,
  } = useUrlaubsantrag(isApprover);

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
      {/* Pass only the needed props to Overview */}
      {/* <UrlaubsantragOverview
        loading={loading}
        totalVacationDays={totalVacationDays}
        remainingVacationDays={remainingVacationDays}
        pendingVacationDays={pendingVacationDays}
        initialRemainingDays={initialRemainingDays}
      /> */}

      {/* Pass all hook props to Table */}
      <UrlaubsantragTable
        loading={loading}
        meineAntraege={meineAntraege}
        pendingAntraege={pendingAntraege}
        approvedAntraege={approvedAntraege}
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        formData={formData}
        setFormData={setFormData}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        vacationDaysInfo={vacationDaysInfo}
        remainingVacationDays={remainingVacationDays}
        pendingVacationDays={pendingVacationDays}
        initialRemainingDays={initialRemainingDays}
        calculateProjectedRemainingDays={calculateProjectedRemainingDays}
        calculateProjectedPendingDays={calculateProjectedPendingDays}
        deleteRequest={deleteRequest}
        onEditApproved={canEditApproved ? editRequest : undefined}
        processRequest={processRequest}
        submitRequest={submitRequest}
        resetForm={resetForm}
        loadPendingRequests={loadPendingRequests}
        isApprover={isApprover}
        existingVacationDates={getExistingVacationDates()}
        checkForOverlap={checkForOverlap}
      />
    </Box>
  );
};

export default Urlaubsantrag;
